import { Ref, useCallback } from "react";
import { DropdownSelector } from "src/components";
import { MaritalStatusValue } from "src/types/Application";

import { enums, formatters } from "@fraction/shared";

const { MARITAL_STATUS_MAP } = formatters.enums;

interface MaritalStatusDropdownProps {
  onChange: (value: MaritalStatusValue) => void;
  value?: MaritalStatusValue;
  focusRef?: Ref<HTMLInputElement>;
}

const ENUM_OPTIONS = [enums.MaritalStatus.MARRIED, enums.MaritalStatus.SINGLE, enums.MaritalStatus.SEPARATED];
const DROPDOWN_OPTIONS = ENUM_OPTIONS.map((type) => ({ value: type, label: MARITAL_STATUS_MAP[type] }));

const MaritalStatusDropdown = ({ onChange, value, focusRef }: MaritalStatusDropdownProps) => {
  const handleChangeMaritalStatus = useCallback(
    (maritalStatus: enums.MaritalStatus) => onChange({ ...value, maritalStatus }),
    [value, onChange]
  );

  return (
    <DropdownSelector
      label="Marital status"
      value={value?.maritalStatus}
      onChange={handleChangeMaritalStatus}
      options={DROPDOWN_OPTIONS}
      focusRef={focusRef}
    />
  );
};

export default MaritalStatusDropdown;
